import { render, staticRenderFns } from "./AppStoreNavigation.vue?vue&type=template&id=4b956a9f&scoped=true"
import script from "./AppStoreNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStoreNavigation.vue?vue&type=style&index=0&id=4b956a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b956a9f",
  null
  
)

export default component.exports